export * from './angularx-qrcode.component';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/node_modules/angularx-qrcode/dist/components/angularx-qrcode/index.js
// module id = ../../../../angularx-qrcode/dist/components/angularx-qrcode/index.js
// module chunks = common